import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import GlossyNav from "@/components/GlossyNav";
import GlossyFooter from "@/components/GlossyFooter";
import EditionPreviewBar from "@/components/EditionPreviewBar";
import { CookieConsent } from "@/components/CookieConsent";
import AskSme from "@/components/AskSme";

export default function MagazineLayout({ children, darkNav = false }) {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 250);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-cream">
      <GlossyNav dark={darkNav} />
      <main>{children}</main>
      <GlossyFooter />
      <EditionPreviewBar />
      <AskSme />
      <CookieConsent />
    </div>
  );
}
